import { Component, Input } from '@angular/core';
import { AvatarSize, DateTimeFormat, IconName, ButtonVariant } from '@yupma/ui-kit';
import { ContactDocument } from 'server-model';
import { RouteLinkGenerator, RouteName } from 'src/app/routing-path';

@Component({
  selector: 'app-contacts-list-item',
  templateUrl: './contacts-list-item.component.html',
  styleUrl: './contacts-list-item.component.scss'
})
export class ContactsListItemComponent {
  @Input() contact: ContactDocument | null = null;
  routeNames = RouteName;
  avatarSizes = AvatarSize;
  dateTimeFormats = DateTimeFormat;
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  displayName: string = '';
  description: string = '';
  route = RouteLinkGenerator.contact('', '');

  constructor() { }

  ngOnInit() {
    if (this.contact) {
      this.init();
    }
  }

  private init() {
    if (this.contact) {
      this.route = RouteLinkGenerator.contact(this.contact.org_id, this.contact.id);
      this.displayName = this.getContactName(this.contact);
      this.description = this.getContactDescription(this.contact);
    }
  }

  getContactName(contact: any): string {
    // Combine first_name and last_name if available
    if (contact.first_name && contact.last_name) {
      return `${contact.first_name} ${contact.last_name}`;
    }
    // Fallback to the first value of email or phone
    if (contact.email && contact.email.length) {
      return contact.email[0].value;
    }
    if (contact.phone && contact.phone.length) {
      return contact.phone[0].value;
    }
    return "- No name -"; // Default if no data is available
  }

  getContactDescription(contact: any): string {
    // Combine job_title and company_name if available
    if (contact.job_title && contact.company_name) {
      return `${contact.job_title} at ${contact.company_name}`;
    }
    if (contact.company_name) {
      return `${contact.company_name}`;
    }
    if (contact.job_title) {
      return `${contact.job_title}`;
    }

    return ""; // Default if no data is available
  }
}
